import { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
// render - sample page

const Index = Loadable(lazy(() => import('pages/index/index')));
const Descargas = Loadable(lazy(() => import('pages/descargas/index')));
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '',
      element: <Index />
    },
    {
      path: '/descargar',
      children: [
        {
          path: '32971ygv3492g7v31276tc181c326tr',
          element: <Descargas />
        }
      ]
    }
  ]
};

export default MainRoutes;
